import styled from "styled-components";

import { safeAreaAbsoluteTop } from "../../../styles/safeArea";

/* The close X used by OrderDetailsTray, OrderGiftDetailsTray,
 * OneOffsDetailsTray, and the generic ModalContainer. Positioned
 * absolutely inside its tray, so the parent's padding-top doesn't
 * push it down — the helper bakes the notch inset into `top`. */
export default styled.img`
  position: absolute;
  left: 25px;
  ${safeAreaAbsoluteTop(25)}
  width: 15px;
  height: 15px;
  cursor: pointer;
`;
